// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1P0e_","colMaxWidth":"Table_colMaxWidth__JEdAq"};